module.exports = __webpack_public_path__ + "static/media/D1_NORM.ea5fe9fa.png";